import {
    makeDataDays,
    makeTooltip,
    makeGrid
} from './make';
import {
    textNumber,
    map
} from '../../../../common/utils';

import {
    formatTipVolume
} from './formatters';

// 成交量数据
function makeDataVolume(klines, {
    colors
}) {
    const {
        up,
        down
    } = colors
    let preClose = 0
    return klines ? map(klines, k => {
        let normal = {
            color: up
        };
        if (k.close < k.open) { // 今开 < 今收
            normal.barGap = 0
            normal.color = down
        } else if (k.close === k.open && k.close < preClose) { // 今开 = 今收 AND今收 < 昨收
            normal.color = down
        }
        preClose = k.close;
        return {
            value: k.volume,
            itemStyle: {
                normal: normal
            }
        }
    }) : [];
}

function makeSeries(klines, {
    colors
}) {
    return [{
        name: `成交量`,
        type: 'bar',
        data: makeDataVolume(klines, {
            colors
        })
    }]
}

// 均线数据
export default function makeVolume({
    klines,
    colors
}) {
    if (!klines) {
        return null
    }
    const curStep = 0
    return {
        color: colors.chartColor,
        backgroundColor: colors.chartBg,
        animation: false,
        tooltip: makeTooltip(klines, {
            colors
        }, formatTipVolume),
        grid: makeGrid({}),
        xAxis: {
            type: "category",
            gridIndex: 0,
            scale: true,
            boundaryGap: false,
            axisTick: {
                show: false
            },
            axisLabel: {
                show: false
            },
            axisLine: {
                onZero: false,
                lineStyle: {
                    color: "#262617"
                }
            },
            splitLine: { //分隔线
                show: true,
                interval: function (index) {
                    if (curStep) {
                        return index === curStep;
                    } else {
                        return false;
                    }
                },
                lineStyle: {
                    color: '#444',
                    width: 1,
                    type: 'solid'
                }
            },
            min: "dataMin",
            max: "dataMax",
            data: makeDataDays(klines)
        },
        yAxis: {
            scale: true,
            position: "left",
            offset: 5,
            min: 0,
            splitArea: {
                show: false
            },
            axisLabel: {
                show: true,
                textStyle: {
                    fontSize: 12,
                    color: "#706F77"
                },
                formatter: function (value, index) {
                    if (index % 2) {
                        value = "";
                    } else if (value > 0) {
                        value = textNumber(value)
                    }
                    return index % 2 ? '' : value > 0 ? textNumber(value) : value;
                }
            },
            splitLine: {
                lineStyle: {
                    color: "#262617"
                }
            }
        },
        series: makeSeries(klines, {
            colors
        })
    }
}
